import React, { useState, useEffect } from 'react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import metadata from './WMICHOCustomCoverageTermDetailView.metadata.json5';

function WMICHOCustomCoverageTermDetailView(props) {
    const {
        id,
        itemVM,
        onSaveItem,
        onCancelItem,
        onValidate: parentOnValidate,
        showErrors: parentShowErrors,
        content,
    } = props;

    const { onValidate, isComponentValid } = useValidation(id);
    const [showErrors, setShowErrors] = useState(false);
    const [currentItem, setCurrentItem] = useState(itemVM);

    useEffect(() => {
        if (parentOnValidate) {
            parentOnValidate(isComponentValid, id);
        }

        return () => (parentOnValidate ? parentOnValidate(true, id) : undefined);
    }, [parentOnValidate, id, isComponentValid]);

    const handleSaveItem = async () => {
        if (isComponentValid) {
            setShowErrors(false);
            await onSaveItem(currentItem);
        } else {
            setShowErrors(true);
        }
    };

    const handleUpdateItem = data => {
        setCurrentItem({ ...data });
    };

    const getFormComponent = () => (
        <ViewModelForm
            uiProps={content}
            model={itemVM}
            overrideProps={{
                '@field': {
                    parentNode: itemVM,
                },
            }}
            onModelChange={handleUpdateItem}
            onValidationChange={onValidate}
            showErrors={showErrors || parentShowErrors}
        />
    );

    const overrideProps = {
        customCoverageTermEditForm: {
            content: getFormComponent(),
        },
    };

    const resolvers = {
        resolveCallbackMap: {
            handleSaveItem,
            onCancelItem,
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

export default WMICHOCustomCoverageTermDetailView;
